import React, { useEffect, useRef } from 'react';
import GlobalLoading from '../GlobalLoading';
import Modal from '../Modals/Modal';
import styles from './StepForm.module.scss';

interface Props {
  isLoading?: boolean;
  headerTitle?: [string, string];
  progress?: number;
  children: React.ReactNode;
  title: string;
  onExitClick: () => void;
}

export default function StepForm({
  children,
  isLoading,
  headerTitle,
  title,
  onExitClick,
}: Props) {
  const contentRef = useRef(null as HTMLDivElement | null);

  useEffect(() => {
    contentRef.current?.scrollTo(0, 0);
  }, [children]);

  return (
    <Modal
      open
      title={title}
      containerProps={{ className: styles.container }}
      closeBtn
      contentRef={contentRef}
      onClose={(reason) => reason === 'closeBtnClick' && onExitClick()}
    >
      <div ref={contentRef} className={styles.content}>
        {isLoading && <GlobalLoading show />}

        {headerTitle && (
          <div className={styles.headerTitle}>
            <h2>
              {headerTitle[0]}
              <span>{headerTitle[1]}</span>
            </h2>
          </div>
        )}

        {children}
      </div>
    </Modal>
  );
}
